<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" href="#" class="btn btn-rounded btn-block-xs-only" style="background: rgb(116, 96, 238); color: #fff;">
            Add Staff
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'name',
    text: 'Staff Name',
    table_popup: true, 
  },
  {
    key: 'personnelCode',
    text: 'Staff No.',
    form_input_validation: [],
  },
];

export default {
  name: "PageStaff",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'User Management' },
        { name: 'Staff' },
      ],

      PARAM,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.loadData();
  },
  methods: {
    loadData() {
      this.$refs['pageTable'].setTableLoading('Loading staff data...');

      let url = this.getUrl();
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.forEach(k => {
            // let user = this.pageUser.find(j => helper.compareID(j.id, k.userID)) || {};
            // k['name'] = user['name'];
            // k['email'] = user['email'];
            k['email'] = k['username'];
          })
          this.$refs['pageTable'].setTableData(response.data);
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'staff data'));
        })
    },

    getUrl() {
      return helper.SERVER_URL + '/api2/personnel/';
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add Staff');
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },
    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    async onModalAddDataClick(selectedData) {
      let feedbackItem = selectedData.name;

      // let temp = {};
      // temp['name'] = selectedData.name;
      // temp['email'] = selectedData.email;

      // this.$refs['pageModal'].setModalLoading('Adding user ' + feedbackItem);
      // let addUserResult = await this.$http
      //     .post(
      //       helper.API_URL + '/api2/auth2/web/register',
      //       querystring.stringify(temp),
      //       helper.createAxiosConfig()
      //     )
      //     .then(response => {
      //     let resultMeta = helper.processAxiosResponse(this, response);
      //       return response.data;
      //       // this.upsertDataComplete('Successfully added internal user ' + feedbackItem);
      //     })
      //     .catch(error => {
      //       this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding user', feedbackItem));
      //     })

      // if(!addUserResult) {
      //   return;
      // }

      // selectedData.userID = addUserResult.userID;
      
      this.$refs['pageModal'].setModalLoading('Adding staff ' + feedbackItem);
      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added staff ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding staff', feedbackItem));
        })
    },
    onModalEditDataClick(selectedData) {
      let feedbackItem = selectedData.name;

      this.$refs['pageModal'].setModalLoading('Updating staff ' + feedbackItem);
      this.$http
        .put(
          this.getUrl() + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    onModalDeleteDataClick(selectedData) {
      let feedbackItem = selectedData.name;

      this.$refs['pageModal'].setModalLoading('Deleting ' + feedbackItem);
      this.$http
        .delete(
          this.getUrl(selectedData.carparkID) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageStaff.vue